// testing 

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../store/authSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { END_POINTS } from "../../../shared";
import {
  Box,
  Typography,
  Button,
  styled,
  Divider,
  useTheme,
  useMediaQuery,
  Card,
  Skeleton,
  IconButton,
  Drawer,
  Grid,
  Stack,
} from "@mui/material";
import * as echarts from "echarts";
import moment from "moment";
import axiosInstance from "../../../axios/axios";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import MonacoDiffEditor, { DiffEditor } from "@monaco-editor/react";
import Exclamation from "../../../assets/Exclamation.png";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import ReactApexChart from "react-apexcharts";
import { diffLines } from "diff";
import Config_Cancel_img from "../../../assets/baseVersion/Config_Cancel_img.svg";
import Config_Tick_img from "../../../assets/baseVersion/Config_Tick_img.svg";
import Cyber_img from "../../../assets/baseVersion/Config_CyberRESILIENCE.svg";
import darklogo from "../../../assets/cyber_resilience_dark.svg";
import { set } from "lodash";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Popover from "@mui/material/Popover";
import CircularProgress from "@mui/material/CircularProgress";
import EventIcon from "@mui/icons-material/Event";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import TimelineIcon from "@mui/icons-material/Timeline";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import dayjs from "dayjs";
import type { editor } from 'monaco-editor';
import { CyberResilienceRediretions } from "../../../modules/dashboard/cyber_resilience/CyberResilienceRediretions";
import Layer123 from "../../../assets/Layer123.svg";

const StyledSelect = styled("select")(({ theme }) => ({
  padding: "8px",
  borderRadius: "4px",
  border: `1px solid ${theme.palette.mode === 'dark' ? '#555' : '#ccc'}`,
  minWidth: "200px",
  fontSize: "14px",
  backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : '#fff',
  color: theme.palette.mode === 'dark' ? '#fff' : '#000',
  "&:focus": {
    outline: "none",
    borderColor: "#1976d2",
  },
  "& option": {
    backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : '#fff',
    color: theme.palette.mode === 'dark' ? '#fff' : '#000',
  },
}));

const ParameterRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "8px 0",
  height: "2rem",
  borderBottom: "1px solid #eee",
  "&:last-child": {
    borderBottom: "none",
  },
});

const ParameterText = styled(Typography)({
  flex: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover": {
    overflow: "visible",
    whiteSpace: "normal",
    minHeight: "20px",
  },
});

const NewAssets = () => {
  const [scannedDates, setScannedDates] = useState<any>([]);
  const [cyberGraohData, setCyberGraphData] = useState<any>([]);
  const timelineChartRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const device_id = location.pathname.split("/").pop();
  const [selectedDate1, setSelectedDate1] = useState<any>(null);
  const [selectedDate2, setSelectedDate2] = useState<any>(null);
  const [selectedScan1, setSelectedScan1] = useState<any>(null);
  const [selectedScan2, setSelectedScan2] = useState<any>(null);
  const [scanDeviceParams, setScanDeviceParams] = useState<any>([]);
  const [newVul, setNewVul] = useState<any>(null);
  const [remediation, setRemediation] = useState<any>(null);
  const [whiteList, setWhiteList] = useState<any>(null);
  const [securityScore, setSecurityScore] = useState<any>(null);
  const [configDiff, setConfigDiff] = useState<any>("");
  const [configDiffModified, setConfigDiffModified] = useState<any>("");
  const [diffResult, setDiffResult] = useState<{
    total: number;
    additions: number;
    deletions: number;
    modified: number;
  }>({
    total: 0,
    additions: 0,
    deletions: 0,
    modified: 0
  });
  const [tempSelectedDate1, setTempSelectedDate1] = useState<string>("");
  const [tempSelectedDate2, setTempSelectedDate2] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [isComparing, setIsComparing] = useState(false);
  const [hasSingleScan, setHasSingleScan] = useState(false);
  const diffEditorRef = useRef<any>(null);
  const [changes, setChanges] = useState<any>([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [initialPosition, setInitialPosition] = useState(0);
  const [isEditorMounted, setIsEditorMounted] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [popupAnchor, setPopupAnchor] = useState<null | HTMLElement>(null);
  const [popupData, setPopupData] = useState<any>(null);
  const [popupLoading, setPopupLoading] = useState(false);
   const [eventClicked, setEventClicked] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [selectedDaysRange, setSelectedDaysRange] = useState<number>(7);
  const [isDateRangeLoading, setIsDateRangeLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const assetsData = useSelector((state: any) => state.auth.assetsData);

  const fetchAssetsList = async () => {
    try {
      const roleReq = {
        type: 1,
      };
      const response = await axiosInstance.post(END_POINTS.DEVICE_LIST, roleReq);
      if (response.status === 200) {
        const result = response.data?.data?.device_list || [];
        const assetsDetails = result
          .filter((data: any) => {
            return data.device_type !== "Endpoint";
          })
          .map((data: any) => ({
            device_name: data.device_name,
            device_id: data.id,
          }));
        dispatch(authActions.updateAssetsList(assetsDetails));
      }
    } catch (error) {
      console.error("Failed to fetch assets data:", error);
    }
  };

  useEffect(() => {
    if (!assetsData || assetsData.length === 0) {
      fetchAssetsList();
    }
  }, [assetsData]);

  const fetchScanDeviceDates = async () => {
    try {
      const end_date = format(new Date(), "yyyy-MM-dd");
      const start_date = format(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
        "yyyy-MM-dd"
      );

      const response = await axiosInstance.post(
        END_POINTS.DEVICE_CYBER_RESILIENCE_SCAN_DATES,
        {
          device_id,
          duration: "custom_date_range",
          start_date,
          end_date,
        }
      );
      if (response?.status === 200 && response?.data?.data?.length > 0) {
        setScannedDates(response?.data?.data);
        setTempSelectedDate1(response?.data?.data[1]?.date_added || "");
        setTempSelectedDate2(response?.data?.data[0]?.date_added || "");
        if (response?.data?.data?.length === 1) {
          const scan1 = response?.data?.data[0];
          setSelectedScan1(scan1);
          setSelectedDate1(new Date(scan1.date_added.replace("-", " ")));
          const scan2 = response?.data?.data[0];
          setSelectedScan2(scan2);
          setSelectedDate2(new Date(scan2.date_added.replace("-", " ")));
          setHasSingleScan(response?.data?.data?.length === 1);
        }
        if (response?.data?.data[0] && response?.data?.data[1]) {
          const scan1 = response?.data?.data[1];
          const scan2 = response?.data?.data[0];
          setSelectedScan1(scan1);
          setSelectedScan2(scan2);
          setSelectedDate1(new Date(scan1.date_added.replace("-", " ")));
          setSelectedDate2(new Date(scan2.date_added.replace("-", " ")));
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching scanned device dates:", error);
    }
  };

  const fetchScannedDetailsData = async () => {
    if (!selectedScan1?.id || !selectedScan2?.id) return null;

    try {
      const response = await axiosInstance.post(END_POINTS.DEVICE_PERAMETER, {
        summary_device_id1: selectedScan1.id,
        summary_device_id2: selectedScan2.id,
      });
      if (response?.status === 200) {
        const data = response?.data?.data;
        console.log("Vulnerability Level Changes:", {
          new_vulnerabilities: data?.new_vul,
          remediated: data?.remediation,
          risk_accepted: data?.whitelisted,
          raw_response: data
        });

        // Ensure we're getting numbers, default to 0 if undefined
        const newVulCount = parseInt(data?.new_vul) || 0;
        const remediationCount = parseInt(data?.remediation) || 0;
        const whiteListCount = parseInt(data?.whitelisted) || 0;

        setScanDeviceParams(data?.parameter_list1);
        setNewVul(newVulCount);
        setRemediation(remediationCount);
        setWhiteList(whiteListCount);
        setSecurityScore(data?.security_score);
      }
      return response;
    } catch (error) {
      console.error("Error fetching scanned details data:", error);
      return null;
    }
  };

  const fetchCyberResilenceGraph = async (days?: number) => {
    try {
      if (!selectedDate1 || !selectedDate2) {
        console.log("Missing dates for cyber resilience graph");
        return null;
      }
      
      const daysToUse = days || selectedDaysRange;
      const end_date = format(new Date(), "yyyy-MM-dd");
      
      // Calculate start_date based on selected days range
      const startDateObj = new Date();
      startDateObj.setDate(startDateObj.getDate() - daysToUse);
      const start_date = format(startDateObj, "yyyy-MM-dd");
      
      console.log(
        "Cyber resilience API request dates:",
        start_date,
        end_date
      );
      
      const response = await axiosInstance.post(
        END_POINTS.CYBER_RESILIENCE_DASHBOARD,
        {
          device_id,
          duration: "custom_date_range",
          start_date: start_date,
          end_date: end_date,
          cve:true,
      intelli_score:true,
      rating:true,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
      );

      if (response?.status === 200) {
        console.log(
          "Cyber resilience API response:",
          response?.data?.data?.graph_data
        );
        setCyberGraphData(response?.data?.data?.graph_data || []);
      }
      return response;
    } catch (error) {
      console.error("Error fetching cyber resilience data:", error);
      return null;
    }
  };

  const handleDaysRangeChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newDaysRange = parseInt(event.target.value);
    setSelectedDaysRange(newDaysRange);
    setIsDateRangeLoading(true);
    
    try {
      // Fetch new data based on the selected range
      await fetchCyberResilenceGraph(newDaysRange);
    } catch (error) {
      console.error("Error fetching data for new date range:", error);
    } finally {
      setIsDateRangeLoading(false);
    }
  };

  const loadGraph = (cyberGraphData: any) => {
    if (!timelineChartRef.current) {
      console.warn("Chart container ref is not available");
      return;
    }

    const existingChart = echarts.getInstanceByDom(timelineChartRef.current);
    if (existingChart) {
      existingChart.dispose();
    }

    const timelineChart = echarts.init(timelineChartRef.current);

    const validData = cyberGraphData?.filter(
      (item: { date_time: any; security_rating: any }) =>
        item.date_time && item.security_rating !== undefined
    );
    if (!validData?.length) {
      console.warn("No valid data points for the chart");
      return;
    }

    const dates = validData.map((item: any) =>
      moment(item.date_time).format("YYYY-MM-DD")
    );
    const values = validData.map((item: any) =>
      parseFloat(item.security_rating)
    );

    console.log("Chart data - dates:", dates);
    console.log("Chart data - values:", values);

    const timelineOption = {
      grid: {
        top: 20,
        right: 20,
        bottom: 30,
        left: 40,
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        formatter: function (params: any) {
          const dataIndex = params[0].dataIndex;
          return `Date: ${dates[dataIndex]}<br/>Score: ${values[dataIndex]}`;
        },
      },
      xAxis: {
        type: "category",
        data: dates,
        axisLabel: {
          interval: Math.ceil(dates.length / 8),
          rotate: 45,
        },
      },
      yAxis: {
        type: "value",
        min: Math.min(...values) * 0.9,
        max: Math.max(...values) * 1.1,
        splitLine: { show: true },
      },
      series: [
        {
          data: values,
          type: "line",
          smooth: true,
          symbol: "circle",
          symbolSize: 6,
          lineStyle: {
            color: "#4F46E5",
            width: 2,
          },
          itemStyle: {
            color: "#4F46E5",
            borderWidth: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(79, 70, 229, 0.2)" },
                { offset: 1, color: "rgba(79, 70, 229, 0)" },
              ],
            },
          },
        },
      ],
    };

    try {
      console.log("Setting chart options:", timelineOption);
      timelineChart.setOption(timelineOption);
      const handleResize = () => {
        timelineChart.resize();
      };
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
        timelineChart.dispose();
      };
    } catch (error) {
      console.error("Error setting chart options:", error);
    }
  };

  const handleDate1Change = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    console.log("Date 1 selected:", value);
    setTempSelectedDate1(value);
  };

  const handleDate2Change = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    console.log("Date 2 selected:", value);
    setTempSelectedDate2(value);
  };

  const handleCompare = async () => {
    if (tempSelectedDate1 && tempSelectedDate2) {
      //setIsComparing(true);
      setTimeout(async () => {
        try {
          setIsLoading(true)
          console.log("Comparing dates:", tempSelectedDate1, tempSelectedDate2);
          const scan1 = scannedDates?.find(
            (date: any) => date.date_added === tempSelectedDate1
          );
          const scan2 = scannedDates?.find(
            (date: any) => date.date_added === tempSelectedDate2
          );

          if (scan1 && scan2) {
            setSelectedScan1(scan1);
            setSelectedScan2(scan2);
            setSelectedDate1(new Date(tempSelectedDate1.replace("-", " ")));
            setSelectedDate2(new Date(tempSelectedDate2.replace("-", " ")));

          const [cyberResponse, scannedDetailResponse, configResponse] =
            await Promise.all([
              fetchCyberResilenceGraph(selectedDaysRange),
              fetchScannedDetailsData(),
              fetchConfigData(),
            ]);

          if (
            cyberResponse?.status === 200 &&
            scannedDetailResponse?.status === 200 &&
            configResponse?.status === 200
          ) {
            setIsLoading(false);
            setIsComparing(false);
            setTimeout(() => {
              if (timelineChartRef.current) {
                loadGraph(cyberResponse?.data?.data?.graph_data);
              }
            }, 200);
          }
          }
        } catch (error) {
          console.error("Error comparing dates:", error);
          setIsComparing(false);
          setIsLoading(false)
        }
      }, 0);
    }
  };

  const fetchConfigData = async () => {
    try {
      const [diffResponse, diffModifiedResponse] = await Promise.all([
        axiosInstance.post(END_POINTS.CONFIG_DIFF, {
          file_id1: selectedScan1.file_id,
        }),
        axiosInstance.post(END_POINTS.CONFIG_DIFF_MODIFIED, {
          file_id2: selectedScan2.file_id,
        }),
      ]);

      if (
        diffResponse?.status === 200 &&
        diffModifiedResponse?.status === 200
      ) {
        const content1 = diffResponse?.data?.data?.content1.join("\n");
        const content2 = diffModifiedResponse?.data?.data?.content2.join("\n");

        setConfigDiff(content1);
        setConfigDiffModified(content2);
        console.log(">>>>>>>>>>>>>");
        calculateDiffCounts();
      }
      return { status: 200 }; // Return success status if we reach here
    } catch (error) {
      console.error("Error fetching config data:", error);
      return null;
    }
  };

  const [currentDiffIndex, setCurrentDiffIndex] = useState(0);
  const diffContainerRef = useRef<HTMLDivElement>(null);

  const scrollToDiff = (index: number) => {
    if (!diffContainerRef.current) return;

    const container = diffContainerRef.current;
    const diffLines = container.querySelectorAll(
      "[class*='diff-added'], [class*='diff-removed']"
    );

    if (diffLines.length === 0) return; // No differences found

    const targetElement = diffLines[index] as HTMLElement;
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // Scroll to the next difference
  const scrollToNextDiff = () => {
    setCurrentDiffIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      scrollToDiff(nextIndex);
      return nextIndex;
    });
  };

  // Scroll to the previous difference
  const scrollToPreviousDiff = () => {
    setCurrentDiffIndex((prevIndex) => {
      const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : 0;
      scrollToDiff(prevIndexValid);
      return prevIndexValid;
    });
  };
  const [addedCount, setAddedCount] = useState(0); // Track added lines count
  const [removedCount, setRemovedCount] = useState(0); // Track removed lines count
  useEffect(() => {
    calculateDiffCounts();
  }, [configDiff, configDiffModified, diffContainerRef]);

  useEffect(() => {
    const container = diffContainerRef.current;
    if (!container) return;

    const observer = new MutationObserver(() => {
      console.log("DOM changed, recalculating diff counts...");
      calculateDiffCounts();
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [configDiff, configDiffModified]);

  const calculateDiffCounts = () => {
    if (!configDiff || !configDiffModified) return;

    // Split the content into lines and filter out empty lines
    const lines1 = configDiff.split('\n').filter((line: string) => line.trim() !== '');
    const lines2 = configDiffModified.split('\n').filter((line: string) => line.trim() !== '');

    let additions = 0;
    let deletions = 0;
    let modified = 0;
    let total = 0;

    // Create maps to track line frequencies
    const map1 = new Map<string, number>();
    const map2 = new Map<string, number>();

    // Count frequencies in first file
    lines1.forEach((line: string) => {
      map1.set(line, (map1.get(line) || 0) + 1);
    });

    // Count frequencies in second file
    lines2.forEach((line: string) => {
      map2.set(line, (map2.get(line) || 0) + 1);
    });

    // Compare the two maps to find changes
    map1.forEach((count, line) => {
      const count2 = map2.get(line) || 0;
      if (count2 === 0) {
        // Line was removed
        deletions += count;
      } else if (count !== count2) {
        // Line frequency changed - this is a modification
        modified += Math.abs(count - count2);
      }
    });

    map2.forEach((count, line) => {
      if (!map1.has(line)) {
        // New line added
        additions += count;
      }
    });

    total = additions + deletions + modified;

    console.log(
      "Change counts:",
      "\nTotal:", total,
      "\nAdditions:", additions,
      "\nDeletions:", deletions,
      "\nModified:", modified
    );

    setDiffResult({
      total,
      additions,
      deletions,
      modified
    });
  };

  console.log(addedCount, "added count");
  console.log(removedCount);

  const splitIntoBatches = (deviceString: string, batchSize = 1) => {
    const devices = deviceString.split("\n");
    let batches = [];
    for (let i = 0; i < devices.length; i += batchSize) {
      batches.push(devices.slice(i, i + batchSize));
    }
    return batches;
  };

  // New useEffect to handle API calls after states are set
  useEffect(() => {
    const makeInitialApiCalls = async () => {
      if (selectedDate1 && selectedDate2 && selectedScan1 && selectedScan2) {
        try {
          const [cyberResponse, scannedDetailResponse, configResponse] =
            await Promise.all([
              fetchCyberResilenceGraph(selectedDaysRange),
              fetchScannedDetailsData(),
              fetchConfigData(),
            ]);

          // Check if all responses are successful
          if (
            cyberResponse?.status === 200 &&
            scannedDetailResponse?.status === 200 &&
            configResponse?.status === 200
          ) {
            // Load graph only if we have cyber graph data
            setIsLoading(false);
            setTimeout(() => {
              if (timelineChartRef.current) {
                loadGraph(cyberResponse?.data?.data?.graph_data);
              }
              if (isEditorMounted && diffEditorRef.current) {
                console.log(
                  "Both config diffs are available, calculating differences..."
                );
              }
            }, 200);
          }
        } catch (error) {
          console.error("Error in initial API calls:", error);
        }
      }
    };

    makeInitialApiCalls();
  }, [
    selectedDate1,
    selectedDate2,
    selectedScan1,
    selectedScan2,
    isEditorMounted,
    selectedDaysRange,
  ]);

  useEffect(() => {
    if (device_id) {
      setIsLoading(true);
      fetchScanDeviceDates();
      setHasSingleScan(false);
      // Fetch initial cyber resilience data with default 7 days
      fetchCyberResilenceGraph(7);
    }
  }, [location.pathname]);

  const extractChanges = () => {
    if (!diffEditorRef.current) {
      console.log("Editor reference not available");
      return;
    }
    try {
      const diffEditor = diffEditorRef.current;
      const modifiedEditor = diffEditor.getModifiedEditor();
      console.log("Modified editor:", modifiedEditor);
      if (!modifiedEditor) {
        console.log("Modified editor not ready yet");
        return;
      }
      const lineChanges = diffEditor.getLineChanges();
      if (!lineChanges || lineChanges.length === 0) {
        console.log("No line changes found - this could be because:");
        console.log("1. The editor is not fully initialized");
        console.log("2. The diff content has not been processed yet");
        console.log("3. There are actually no changes between the files");
        return;
      }
      let added = 0;
      let removed = 0;
      let modified = 0;
      interface LineChange {
        originalStartLineNumber: number;
        originalEndLineNumber: number;
        modifiedStartLineNumber: number;
        modifiedEndLineNumber: number;
      }
      interface DiffResult {
        additions: number;
        deletions: number;
        modified: number;
        total: number;
      }
      lineChanges.forEach((change: LineChange) => {
        const originalLength =
          change.originalEndLineNumber - change.originalStartLineNumber + 1;
        const modifiedLength =
          change.modifiedEndLineNumber - change.modifiedStartLineNumber + 1;

        if (change.originalEndLineNumber === 0) {
          added += modifiedLength;
        } else if (change.modifiedEndLineNumber === 0) {
          removed += originalLength;
        } else {
          modified += Math.max(originalLength, modifiedLength);
        }
      });
      console.log("Change counts:", { added, removed, modified });
      setDiffResult((prev: DiffResult) => ({
        ...prev,
        additions: added,
        deletions: removed,
        modified: modified,
        total: added + removed + modified,
      }));
      const newChanges = lineChanges.map((change: any) => ({
        modifiedStart: change.modifiedStartLineNumber,
        modifiedEnd: change.modifiedEndLineNumber,
      }));
      console.log("Processed changes:", newChanges);
      setChanges(newChanges);
      if (modifiedEditor) {
        const scrollTop = modifiedEditor.getScrollTop();
        setInitialPosition(scrollTop || 0);
      }
    } catch (error) {
      console.error("Error extracting changes:", error);
    }
  };

  const scrollToChange = (index: any) => {
    const modifiedEditor = diffEditorRef.current?.getModifiedEditor?.();
    if (!modifiedEditor || !changes.length) return;
    modifiedEditor.revealLineInCenter(changes[index].modifiedStart);
  };

  const scrollToInitialPosition = () => {
    const modifiedEditor = diffEditorRef.current?.getModifiedEditor?.();
    if (modifiedEditor) modifiedEditor.setScrollTop(initialPosition);
  };

  const handleNext = () => {
    if (!changes.length) return;
    const nextIndex = (currentIndex + 1) % changes.length;
    setCurrentIndex(nextIndex);
    scrollToChange(nextIndex);
  };

  const handlePrev = () => {
    if (!changes.length) return;
    if (currentIndex <= 0) {
      setCurrentIndex(-1);
      scrollToInitialPosition();
    } else {
      const prevIndex = currentIndex - 1;
      setCurrentIndex(prevIndex);
      scrollToChange(prevIndex);
    }
  };

  const chartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: "area",
      stacked: false,
      height: isTablet ? 250 : 350,
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        show: false,
      },
      background: "transparent",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 1.5,
    },
    markers: {
      size: 0,
      hover: {
        size: 5,
      },
    },
    title: {
      text: "",
      align: "left",
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: isDarkMode ? 0.4 : 0.5,
        opacityTo: isDarkMode ? 0.05 : 0.1,
        stops: [0, 90, 100],
      },
    },
    grid: {
      borderColor: isDarkMode ? "#333333" : "#e7e7e7",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        style: {
          colors: isDarkMode ? "#b3b3b3" : "#6B7280",
        },
        datetimeFormatter: {
          year: "yyyy",
          month: "MMM",
          day: "dd MMM",
          hour: "HH:mm",
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      title: {
        text: "",
      },
      labels: {
        style: {
          colors: isDarkMode ? "#b3b3b3" : "#6B7280",
        },
        formatter: (value) => `${value.toFixed(0)}`,
      },
    },
    tooltip: {
      shared: true,
      x: {
        format: "dd MMM yyyy",
      },
      y: {
        formatter: (val) => `${val.toFixed(0)}`,
      },
      theme: isDarkMode ? "dark" : "light",
    },
    colors: ["#FF6B00"],
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 220,
          },
          title: {
            fontSize: "14px",
          },
        },
      },
    ],
  };
  const processChartData = (data: any[]) => {
    if (!data?.length) return [];

    const validData = data.filter(
      (item: { date_time: any; security_rating: any }) =>
        item.date_time && item.security_rating !== undefined
    );

    return validData.map((item: any) => ({
      x: new Date(item.date_time).getTime(),
      y: parseFloat(item.security_rating),
      new_event: item.new_event,
      // date_time: new Date().toISOString()
    }));
  };

  const series = [
    {
      name: "Security Rating",
      data: processChartData(cyberGraohData),
    },
  ];

  const overrideButtonStyles = {
    "&:disabled": {
      backgroundColor: "unset", // Override with a lighter gray color
      color: isDarkMode ? "white" : "black", // Override with a different text color
      opacity: "0.5", // Remove opacity effect
    },
  };

  const LoadingSkeleton = () => (
    <>
      {/* Left Section Skeleton */}
      <Box
        sx={{
          width: "25%",
          display: "flex",
          flexDirection: "column",
          padding: "10px",
          gap: "10px",
        }}
      >
        {/* Top Box Skeleton */}
        <Card
          sx={{
            height: "40%",
            padding: "20px",
            backgroundColor: isDarkMode ? "#1E1E1E" : "white",
          }}
        >
          <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Skeleton variant="text" width="20%" height={30} />
            <Skeleton variant="rectangular" width="25%" height={40} />
            <Skeleton variant="rectangular" width="25%" height={40} />
            <Skeleton variant="rectangular" width="15%" height={40} />
          </Box>
          <Skeleton variant="rectangular" height="calc(100% - 100px)" />
        </Card>

        {/* Bottom Box Skeleton */}
        <Card
          sx={{
            height: "calc(100% - 320px)",
            padding: "20px",
            backgroundColor: isDarkMode ? "#1E1E1E" : "white",
          }}
        >
          <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
          {[1, 2, 3, 4, 5].map((item) => (
            <Box key={item} sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Skeleton variant="text" width="60%" height={30} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          ))}
        </Card>
      </Box>

      {/* Right Section Skeleton */}
      <Box
        sx={{
          width: "75%",
          display: "flex",
          flexDirection: "column",
          padding: "10px",
          gap: "10px",
        }}
      >
        {/* Upper Box Skeleton */}
        <Card
          sx={{
            height: "40%",
            padding: "20px",
            backgroundColor: isDarkMode ? "#1E1E1E" : "white",
          }}
        >
          <Skeleton variant="text" width="70%" height={40} sx={{ mb: 2 }} />
          <Box sx={{ display: "flex", gap: 4, mb: 2 }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="50%" height={30} sx={{ mb: 2 }} />
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                {[1, 2, 3, 4].map((item) => (
                  <Box key={item}>
                    <Skeleton variant="text" width={60} height={40} />
                    <Skeleton variant="text" width={80} height={20} />
                  </Box>
                ))}
              </Box>
            </Box>
            <Divider orientation="vertical" flexItem />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="50%" height={30} sx={{ mb: 2 }} />
              <Box sx={{ display: "flex", gap: 3 }}>
                {[1, 2, 3].map((item) => (
                  <Box key={item}>
                    <Skeleton variant="text" width={60} height={40} />
                    <Skeleton variant="text" width={80} height={20} />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Card>

        {/* Lower Box Skeleton */}
        <Card
          sx={{
            height: "calc(100% - 320px)",
            padding: "20px",
            backgroundColor: isDarkMode ? "#1E1E1E" : "white",
          }}
        >
          <Skeleton variant="text" width="100%" height={40} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height="calc(100% - 60px)" />
        </Card>
      </Box>
    </>
  );

  const highlightLines = () => {
    if (!diffContainerRef.current) return;

    const lines = diffContainerRef.current.querySelectorAll('.diff-line');
    lines.forEach((line: Element) => {
      const content = line.textContent || '';

      // Check if the line is part of a vulnerability section
      const isVulnerabilitySection = content.includes('Vulnerability:') ||
        content.includes('CVE-') ||
        content.includes('Risk Level:');

      const bgColor = isDarkMode ? {
        ALL: "rgba(0, 0, 0, 0.2)",
        Addition: "rgba(0, 166, 27, 0.2)",
        New: "rgba(0, 166, 27, 0.2)",
        Deletion: "rgba(240, 60, 60, 0.2)",
        Modified: "rgba(105, 101, 149, 0.2)",
        Remediated: "rgba(103, 0, 4, 0.2)",
        "Risk accepted": "rgba(242, 191, 0, 0.2)"
      } : {
        ALL: "rgba(0, 0, 0, 0.1)",
        Addition: "rgba(0, 166, 27, 0.1)",
        New: "rgba(0, 166, 27, 0.1)",
        Deletion: "rgba(240, 60, 60, 0.1)",
        Modified: "rgba(105, 101, 149, 0.1)",
        Remediated: "rgba(103, 0, 4, 0.1)",
        "Risk accepted": "rgba(242, 191, 0, 0.1)"
      };

      // First check if it's a vulnerability section
      if (isVulnerabilitySection) {
        const parentElement = (line as HTMLElement).closest('.diff-block');
        if (parentElement) {
          const allLines = parentElement.querySelectorAll('.diff-line');
          allLines.forEach(l => {
            if ((l as HTMLElement).classList.contains('diff-added')) {
              (l as HTMLElement).style.backgroundColor = bgColor.New;
            } else if ((l as HTMLElement).classList.contains('diff-removed')) {
              (l as HTMLElement).style.backgroundColor = bgColor.Remediated;
            }
          });
        }
      } else {
        // Handle regular configuration changes
        Object.entries(bgColor).forEach(([key, color]) => {
          if (content.includes(key)) {
            (line as HTMLElement).style.backgroundColor = color;
          }
        });
      }
    });
  };

// Helper function to check if event is clickable
const isEventClickable = (event: any) => {
    return !(
      event.event_code === "asset_recom" ||
      event.event_code === "device_decom" ||
      event.event_code === "asset_decom" ||
      event.event_code === "device_recom"
    );
  };

const handleEventCardClick = (event: any) => {
    if (!isEventClickable(event)) {return;}
    setSelectedEvent(event);
    setEventClicked(true);
    console.log("Event card clicked:", event);
  };

  useEffect(() => {
    // Add a small delay to ensure the diff viewer has rendered
    const timer = setTimeout(highlightLines, 100);
    return () => clearTimeout(timer);
  }, [configDiff, configDiffModified, isDarkMode]);

  // Add an observer to handle dynamic content changes
  useEffect(() => {
    const observer = new MutationObserver(() => {
      highlightLines();
    });

    if (diffContainerRef.current) {
      observer.observe(diffContainerRef.current, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    return () => observer.disconnect();
  }, []);

  const handleChartClick = async (event: any, chartContext: any, config: any) => {
    const dataIndex = config.dataPointIndex;
    if (dataIndex === -1) return;
    const data = cyberGraohData[dataIndex];
    if (data?.new_event) {
      setPopupLoading(true);
      setPopupAnchor(event.target);
      try {
        const response = await axiosInstance.post("securityscan/daily-event-data", {
    date: data.date_time,
    timezone: "Asia/Calcutta"
});   
         const formattedData = {
        date: data.date_time,
        data: response.data.data.event_data.map((event: any) => ({
          time: dayjs(event.event_date).format('HH:mm:ss'),
          security_score: event.current_score.toFixed(2),
          score_change: event.score_difference,
          event_type: event.event_name,
          event_code: event.event_code,
          referenceID: event.reference_id
        }))
      };
        setPopupData(formattedData);
      } catch (err) {
        setPopupData({ error: "Failed to load details" });
      }
      setPopupLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      {(isLoading || isComparing) && <LoadingSkeleton />}
      {!isLoading && (
        <>
          {/* Left Section */}
          <Box
            sx={{
              width: "25%",
              display: "flex",
              flexDirection: "column",
              padding: "0px 10px 10px 0px",
              gap: "10px",
              height: "100%",
            }}
          >
            {/* Top Box */}
            <Card
              sx={{
                height: "48%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: isDarkMode ? "#1E1E1E" : "#ffffff",
                borderRadius: "8px",
              }}
            >
              {scannedDates?.length > 0 ? (
                <>
                  {/* Header */}
                    <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      boxShadow: isDarkMode
                      ? "0px 2px 8px rgba(0,0,0,0.25)"
                      : "0px 2px 8px rgba(0, 0, 0, 0.05)",
                      mb: 1,
                      width: "100%",
                      padding: 1,
                    }}
                    >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 700, fontSize: 'clamp(10px, 1vw, 12px)', color: isDarkMode ? "#FFFFFF" :  "#1C1C1C"}}
                    >
                      CONFIG DIFF ({moment(selectedDate1).format("DD MMM").toUpperCase()} -{" "}
                      {moment(selectedDate2).format("DD MMM").toUpperCase()})
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography sx={{ color: "#696595", fontWeight: 700, fontSize: 'clamp(8px, 0.8vw, 10px)' }}>
                        Security Score Change:
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", fontWeight: "bold", fontSize: "10px" }}>
                        {securityScore > 0 ? (
                          <Box component="span" sx={{  display: "flex", alignItems: "center" }}>
                            <ArrowOutwardIcon sx={{ fontSize: 14, color: "#00A61B" }} />
                           <Typography sx={{ fontWeight: 700, fontSize: 'clamp(10px, 1vw, 12px)' }}>{Math.abs(securityScore)}</Typography> 
                          </Box>
                        ) : (
                          <Box component="span" sx={{  display: "flex", alignItems: "center" }}>
                            <CallReceivedIcon sx={{ fontSize: 14, color: isDarkMode ? "#F03C3C" : "#F03C3C", }} />
                             <Typography sx={{ fontWeight: 700, fontSize: 'clamp(10px, 1vw, 12px)' }}>{Math.abs(securityScore)}</Typography> 
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ padding:1}}>
                  {/* Configuration Level Changes */}
                  <Box sx={{ flex: 1, minWidth: 250, mb: 'clamp(8px, 1vw, 16px)'}}>
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 'clamp(8px, 1vw, 16px)'}}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          color: isDarkMode ? "#FFFFFF" : "#2B335F",
                          fontSize: 'clamp(12px, 1.5vw, 15px)',
                        }}
                      >
                        Configuration Level Changes
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                      {[
                        { label: "All", value: diffResult?.total, icon: <ArrowOutwardIcon sx={{ color: "#00A61B" }} /> },
                        { label: "Addition", value: diffResult?.additions, icon: <ArrowOutwardIcon sx={{ color: "#00A61B" }} /> },
                        { label: "Deletion", value: diffResult?.deletions, icon: <CallReceivedIcon sx={{ color: "#F03C3C" }} /> },
                        { label: "Modified", value: diffResult?.modified, icon: <CallReceivedIcon sx={{ color: "#F03C3C" }} /> },
                      ].map((item) => (
                        <Box key={item.label} sx={{ textAlign: "center" }}>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                            {item.icon}
                            <Typography sx={{ fontSize: 'clamp(15px, 2vw, 20px)', fontWeight: 500 }}>
                              {item.value || 0}
                            </Typography>
                          </Box>
                          <Typography sx={{ fontSize: 'clamp(10px, 1vw, 12px)', fontWeight: "bold", color: "text.secondary" }}>
                            {item.label}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* Divider Between Sections */}
                  <Divider sx={{ my: 'clamp(8px, 1vw, 16px)'}} />

                  {/* Vulnerability Level Changes */}
                  <Box sx={{ flex: 1, minWidth: 250,   mt: 'clamp(4px, 1vw, 16px)'}}>
                    <Box sx={{ display: "flex", justifyContent: "center",  }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: isDarkMode ? "#FFFFFF" : "#2B335F",
                        fontSize: 'clamp(12px, 1vw, 15px)',
                        mb: 1,
                      }}
                    >
                      Vulnerability Level Changes
                    </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                      {[
                        { label: "New", value: newVul, icon: <ArrowOutwardIcon sx={{ color: "#00A61B" }} /> },
                        { label: "Remediated", value: remediation, icon: <CallReceivedIcon sx={{ color: "#F03C3C" }} /> },
                        { label: "Risks accepted", value: whiteList, icon: <ArrowOutwardIcon sx={{ color: "#00A61B" }} /> },
                      ].map((item) => (
                        <Box key={item.label} sx={{ textAlign: "center" }}>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                            {item.icon}
                            <Typography sx={{ fontSize: 'clamp(15px, 2vw, 20px)', fontWeight: 500 }}>
                              {item.value || 0}
                            </Typography>
                          </Box>
                          <Typography sx={{ fontSize: 'clamp(10px, 1vw, 12px)', fontWeight: "bold", color: "text.secondary" }}>
                            {item.label}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  </Box>
                </>
              ) : (
                <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography variant="body2" color="textSecondary">
                    No Data
                  </Typography>
                </Box>
              )}
            </Card>


            {/* Bottom Box */}
            <Card
              sx={{
                height: "52%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: isDarkMode ? "#1E1E1E" : "white",
                borderRadius: "8px",
                boxShadow: isDarkMode
                  ? "0px 2px 8px rgba(0,0,0,0.25)"
                  : "0px 2px 8px rgba(0, 0, 0, 0.05)",
                // padding: "10px",
                gap: "10px",

              }}
            >
              {scannedDates?.length > 0 || scanDeviceParams?.length > 0 ? (

                <Box sx={{ width: "100%", height: "100%" }}>
                  {/* Header */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      // fontWeight: "bold",
                      
                      backgroundColor: isDarkMode ? "#2A2A2A" : "#F5F5F5",
                      borderRadius: "6px 6px 0 0",
                      borderBottom: "1px solid #E0E0E0",
                    }}
                  >
                    <Typography sx={{ flex: 1, fontWeight: 700, 
                      fontSize: "clamp(12px, 1vw, 14px)", }}>RECOMMENDATION</Typography>
                    <Typography sx={{ width: "80px", fontWeight: 700, 
                      fontSize: "clamp(12px, 1vw, 14px)", textAlign: "center" }}>
                      {moment(selectedDate1).format("DD MMM").toUpperCase()}
                    </Typography>
                    {!hasSingleScan && (
                      <Typography sx={{ width: "80px", fontWeight: 700, 
                      fontSize: "clamp(12px, 1vw, 14px)", textAlign: "center" }}>
                        {moment(selectedDate2).format("DD MMM").toUpperCase()}
                      </Typography>
                    )}
                  </Box>

                  {/* Rows */}
                  <Box className="scroll" sx={{ display: "flex", flexDirection: "column", width: "100%", height: "89%" }}>
                    {scanDeviceParams?.map((param: any, index: any) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: "8px 12px",
                          borderBottom: "1px solid #E0E0E0",
                          backgroundColor:
                            index % 2 === 0
                              ? isDarkMode
                                ? "#1A1A1A"
                                : "#FAFAFA"
                              : "transparent",
                        }}
                      >
                        {/* Parameter Name + Icon */}
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            overflow: "hidden",
                          }}
                        >
                          <Typography
                            variant="body2"
                            title={param.parameter}
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontWeight: 500,
                              maxWidth: "90%",
                            }}
                          >
                            {param.parameter}
                          </Typography>
                          {param.white_list?.value && (
                            <img src={Exclamation} alt="warning" height="clamp(15, 1.5vw, 20)" />
                          )}
                        </Box>

                        {/* Date 1 status */}
                        <Box sx={{ width: "80px", textAlign: "center" }}>
                          <img
                            src={param.is_passed_1 ? Config_Tick_img : Config_Cancel_img}
                            alt={param.is_passed_1 ? "Pass" : "Fail"}
                            style={{ padding: 5 }}
                          />
                        </Box>

                        {/* Date 2 status */}
                        {!hasSingleScan && (
                          <Box sx={{ width: "80px", textAlign: "center" }}>
                            <img
                              src={param.is_passed_2 ? Config_Tick_img : Config_Cancel_img}
                              alt={param.is_passed_2 ? "Pass" : "Fail"}
                              style={{ padding: 5 }}
                            />
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                </Box>
              ) : (
                <Typography variant="body1" color="textSecondary">
                  No Data
                </Typography>
              )}
            </Card>
          </Box>

          {/* Right Section */}
          <Box
            sx={{
              width: "75%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              padding: "0px 10px 10px 0px",
              gap: "10px",
            }}
          >
            {/* Upper Box */}
            <Card
              sx={{
                height: "48%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: isDarkMode ? "#1E1E1E" : "#ffffff",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // padding: "12px",
                gap: "10px",
              }}
            >
              {/* Header: Logo, Posture Score & Date Range */}
              <Box sx={{ display: "flex",height:'35px', justifyContent: "space-between", alignItems: "center", padding: "2px 12px 2px 12px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                <Box>
                  <img
                    src={theme.palette.mode === "dark" ? darklogo : Cyber_img}
                    alt="Cyber Logo"
                    style={{ height: "clamp(20, 3vw, 42)" }}
                  />
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography variant="body2" sx={{ color: "red", display: "flex", alignItems: "center", gap: 0.5 }}>
                    <span style={{
                      width: 8,
                      height: 8,
                      backgroundColor: "red",
                      borderRadius: "50%",
                      display: "inline-block"
                    }}></span>
                    Posture Score 
                  </Typography>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <StyledSelect value={selectedDaysRange} onChange={handleDaysRangeChange}>
                      <option value="7">Last 7 Days</option>
                      <option value="14">Last 14 Days</option>
                      <option value="30">Last 30 Days</option>
                    </StyledSelect>
                    {isDateRangeLoading && (
                      <CircularProgress size={16} sx={{ color: isDarkMode ? '#fff' : '#1976d2' }} />
                    )}
                  </Box>
                </Box>
              </Box>
               
              {/* Compare Section */}
             {scannedDates?.length > 0 && (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "clamp(30px, 5vw, 60px)", // responsive height
padding: "0px clamp(8px, 1vw, 16px)",



    }}
  >
    {/* Date selectors */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "clamp(4px, 0.5vw, 12px)", // responsive gap
      }}
    >
      <Typography
        variant="body2"
        fontWeight={500}
        fontSize="clamp(10px, 1vw, 13px)" // responsive font size
      >
        Compare selection:
      </Typography>

      {/* Date 1 dropdown */}
      <StyledSelect
        value={tempSelectedDate1}
        onChange={handleDate1Change}
        sx={{
          backgroundColor: isDarkMode ? "#1E1E1E" : "#fff",
          color: isDarkMode ? "#fff" : "#000",
          fontSize: "clamp(10px, 1vw, 13px)",
          padding: "clamp(4px, 0.6vw, 8px)",
        }}
      >
        {scannedDates.map((date: any) => (
          <option key={date.date_added} value={date.date_added}>
            {date.date_added}
          </option>
        ))}
      </StyledSelect>

      {/* Date 2 dropdown */}
      <StyledSelect
        value={tempSelectedDate2}
        onChange={handleDate2Change}
        sx={{
          backgroundColor: isDarkMode ? "#1E1E1E" : "#fff",
          color: isDarkMode ? "#fff" : "#000",
          fontSize: "clamp(10px, 1vw, 13px)",
          padding: "clamp(4px, 0.6vw, 8px)",
        }}
      >
        {scannedDates.map((date: any) => (
          <option key={date.date_added} value={date.date_added}>
            {date.date_added}
          </option>
        ))}
      </StyledSelect>
    </Box>

    {/* Compare Button */}
    <Button
      variant="outlined"
      size="small"
      onClick={handleCompare}
      disabled={!tempSelectedDate1 || !tempSelectedDate2}
      sx={{
        textTransform: "none",
        fontSize: "clamp(10px, 1vw, 13px)",
        padding: "clamp(4px, 0.6vw, 8px) clamp(8px, 1vw, 14px)",
        height: "clamp(20px, 5vw, 40px)", // responsive height
        borderColor: isDarkMode ? "rgba(255, 255, 255, 0.5)" : undefined,
        color: isDarkMode ? "#FFFFFF" : undefined,
        "&:hover": {
          borderColor: isDarkMode ? "rgba(255, 255, 255, 0.8)" : undefined,
          backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : undefined,
        },
      }}
    >
      Compare
    </Button>
  </Box>
)}


              {/* Chart Section */} 
              <Box sx={{ height: "calc(100% - 90px)", pb: 2, pl: 2, pr: 2 }}>
                {isDateRangeLoading ? (
                  <Box sx={{ 
                    height: "100%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: 2
                  }}>
                    <CircularProgress size={40} sx={{ color: isDarkMode ? '#fff' : '#1976d2' }} />
                    <Typography variant="body2" sx={{ color: isDarkMode ? '#b3b3b3' : '#666' }}>
                      Loading chart data...
                    </Typography>
                  </Box>
                ) : (
                  <ReactApexChart
                    options={{
                      ...chartOptions,
                      grid: {
                        ...chartOptions.grid,
                        borderColor: isDarkMode ? "#333" : "#e0e0e0",
                        xaxis: { lines: { show: true } },
                        yaxis: { lines: { show: true } },
                      },
                      yaxis: { ...chartOptions.yaxis, min: 0, max: 100 },
                      chart: {
                        ...chartOptions.chart,
                        events: {
                          click: function (event, chartContext, { dataPointIndex, seriesIndex }) {
                            if (dataPointIndex >= 0) {
                              const dataPoint = series[0].data[dataPointIndex];
                              if (dataPoint?.new_event) {
                                handleChartClick(event, chartContext, { dataPointIndex, seriesIndex });
                              }
                            }
                          },
                        },
                      },
                    }}
                    series={series}
                    type="area"
                    height="100%"
                    width="100%"
                  />
                )}
              </Box>
             
            </Card>

            {/* Lower Box */}
               <Card
              sx={{
                height: "52%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: isDarkMode ? "#1E1E1E" : "white",
                borderRadius: "8px",
                  boxShadow: isDarkMode
                      ? "0px 2px 8px rgba(0,0,0,0.25)"
                      : "0px 2px 8px rgba(0, 0, 0, 0.05)",
                // padding: "1px",
                gap: "10px",
              }}
            >
              {scannedDates?.length > 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    width: "100%",
                    backgroundColor: isDarkMode ? "#1E1E1E" : "white",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                      py: 1,
                      backgroundColor: isDarkMode ? "#1E1E1E" : "#F2F1FE",
                        boxShadow: isDarkMode
                      ? "0px 2px 8px rgba(0,0,0,0.25)"
                      : "#DBDBEF",
                      // borderRadius: 1,
                    }}
                  >
                    {hasSingleScan && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 1,
                          // backgroundColor: isDarkMode ? "#1E1E1E" : "#f5f5f5",
                          width: "100%",
                        }}
                      >
                        <Typography variant="subtitle2">
                          {moment(selectedDate1).format(
                            "DD MMM, YYYY - HH:mm:ss"
                          )}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: "text.secondary" }}
                        >
                          Security Score:
                          <span
                            style={{
                              color:
                                selectedScan1?.security_score < 50
                                  ? (isDarkMode ? "#FF4444" : "#670004") // Red for below 50
                                  : selectedScan1?.security_score <= 80
                                    ? "#E85800" // Yellow for 50 to 80
                                    : "#00A61B", // Green for above 80
                              marginLeft: "4px",
                              fontWeight: "bold",
                            }}
                          >
                            {selectedScan1?.security_score}
                          </span>
                        </Typography>
                      </Box>
                    )}
                    {!hasSingleScan && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            // backgroundColor: isDarkMode ? "#1E1E1E" : "#f5f5f5",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ color: "#8480AD" }}
                          >
                            {moment(selectedDate1).format(
                              "DD MMM, YYYY - HH:mm:ss"
                            )}
                          </Typography>
                          <Typography variant="subtitle2">
                            Security Score:
                            <span
                              style={{
                                color:
                                  selectedScan1?.security_score < 50
                                    ? (isDarkMode ? "#FF4444" : "#670004") // Red for below 50
                                    : selectedScan1?.security_score <= 80
                                      ? "#E85800" // Yellow for 50 to 80
                                      : "#00A61B", // Green for above 80
                                marginLeft: "4px",
                                fontWeight: "bold",
                              }}
                            >
                              {selectedScan1?.security_score}
                            </span>
                          </Typography>
                        </Box>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ color: "#8480AD" }}
                          >
                            {moment(selectedDate2).format(
                              "DD MMM, YYYY - HH:mm:ss"
                            )}
                          </Typography>
                          <Typography variant="subtitle2">
                            Security Score:
                            <span
                              style={{
                                color:
                                  selectedScan2?.security_score < 50
                                    ? (isDarkMode ? "#FF4444" : "#670004") // Red for below 50
                                    : selectedScan2?.security_score <= 80
                                      ? "#E85800" // Yellow for 50 to 80
                                      : "#00A61B", // Green for above 80
                                marginLeft: "4px",
                                fontWeight: "bold",
                              }}
                            >
                              {selectedScan2?.security_score}
                            </span>
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                   {!hasSingleScan && (
                      <div
                      className="nav-btn"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "2px 10px 2px 10px",
                        marginBottom: "1px",
                        // backgroundColor: isDarkMode ? "#1E1E1E" : "#f5f5f5",
                         boxShadow: isDarkMode
                      ? "0px 2px 8px rgba(0,0,0,0.25)"
                      : "0px 2px 8px rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <div className="config-cnt">
                        <Typography
                          variant="body2"
                          sx={{ color: "#B61111" , fontWeight: 700, 
                      fontSize: "clamp(10px, 1.5vw, 14px)", }}
                        >
                          Configuration Difference:{" "}
                          {currentIndex === -1 ? 0 : currentIndex + 1} of{" "}
                          {changes.length}
                        </Typography>
                      </div>
                      <div>
                        <IconButton
                          onClick={handlePrev}
                          disabled={currentIndex === -1}
                        >
                          <ExpandLessIcon sx={{ color: isDarkMode ? "rgba(255, 255, 255, 0.3)" : "#000000" }} />
                        </IconButton>

                        <IconButton
                          onClick={handleNext}
                          disabled={currentIndex === changes.length - 1}
                        >
                          <ExpandMoreIcon  sx={{ color: isDarkMode ? "rgba(255, 255, 255, 0.3)" : "#000000" }}/>
                        </IconButton>
                        {/* 
                 <button disabled={currentIndex === -1} onClick={handlePrev} className="rotate-180">
                   <span className="material-icons">expand_more</span>
                 </button>
                 <button disabled={currentIndex === changes.length - 1} onClick={handleNext}>
                   <span className="material-icons">expand_more</span>
                 </button> */}
                      </div>
                    </div>
                    )}
                  <Box
                    style={{
                      height: "100%",
                      width: "100%",
                      overflow: "auto",
                      // scrollbarWidth: "none",
                    }}
                  >
                   
                      {!hasSingleScan && (
                          <DiffEditor
                            key={`diff-editor-${isDarkMode}`}
                            height="100%"
                            width="100%"
                            language="plaintext"
                            original={configDiff}
                            modified={configDiffModified}
                            options={{
                              readOnly: true,
                              enableSplitViewResizing: true,
                              renderOverviewRuler: false,
                            }}
                            onMount={(editor, monaco) => {
                              diffEditorRef.current = editor;
                              setIsEditorMounted(true);
                            
                              // Define and apply the theme based on isDarkMode
                              const background = isDarkMode ? '#1E1E1E' : '#FFFFFF';
                              const foreground = isDarkMode ? '#FFFFFF' : '#000000';
                            
                              monaco.editor.defineTheme('custom-theme', {
                                base: isDarkMode ? 'vs-dark' : 'vs',
                                inherit: true,
                                rules: [
                                  {
                                    token: '',
                                    foreground: foreground,
                                    background: background,
                                  },
                                ],
                                colors: {
                                  'editor.background': background,
                                  'editor.foreground': foreground,
                                  'diffEditor.insertedTextBackground': isDarkMode ? '#144212' : '#DDFFDD',
                                  'diffEditor.removedTextBackground': isDarkMode ? '#601212' : '#FFDDDD',
                                },
                              });
                            
                              monaco.editor.setTheme('custom-theme');
                            
                              

                              // Wait for the editor to be fully initialized
                              const checkEditorReady = () => {
                                const modifiedEditor =
                                  editor.getModifiedEditor();
                                if (modifiedEditor) {
                                  // Subscribe to diff update events
                                  editor.onDidUpdateDiff(() => {
                                    console.log(
                                      "Diff updated, extracting changes..."
                                    );
                                    extractChanges();
                                  });

                                  // Initial extraction after editor is ready
                                  extractChanges();
                                } else {
                                  console.log(
                                    "Editor not ready yet, retrying..."
                                  );
                                  setTimeout(checkEditorReady, 100);
                                }
                              };

                              checkEditorReady();
                            }}
                          />
                      )}
                    
                 
                      {hasSingleScan && (
                     <MonacoDiffEditor
                height="100%"
                width="100%"
                language="plaintext"
                value={configDiff}
                theme={isDarkMode ? "vs-dark" : "vs"}
                options={{
                  readOnly: true,
                  minimap: { enabled: false },
                  scrollbar: { vertical: "visible" },
                }}
              />
                  )}
                   
                  </Box>
                </Box>
              ) : (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  No Data
                </Typography>
              )}
            </Card>
          </Box>
          
          {/* <Popover
            open={Boolean(popupAnchor)}
            anchorEl={popupAnchor}
            onClose={() => { setPopupAnchor(null); setPopupData(null); }}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Box sx={{ p: 2, minWidth: 250 }}>
              {popupLoading ? (
                <CircularProgress size={24} />
              ) : popupData ? (
                // Render your popupData here
                <div>
                  <Typography variant="subtitle1">Event Details</Typography>
                  <pre style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(popupData, null, 2)}</pre>
                </div>
              ) : (
                <Typography>No data</Typography>
              )}
            </Box>
          </Popover> */}

          <Drawer
        anchor="right"
        open={Boolean(popupAnchor)}
        onClose={() => { setPopupAnchor(null); setPopupData(null); }}
        sx={{
          '& .MuiDrawer-paper': {
            width: { xs: '100%', sm: '50%' },
            bgcolor: theme.palette.background.paper,
            boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <Box sx={{
            p: 2,
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            <EventIcon color="primary" />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Security Events - {popupData?.date || ''}
            </Typography>
            <IconButton
              onClick={() => setPopupAnchor(null)}
              size="small"
              sx={{
                color: 'text.secondary',
                '&:hover': { color: 'text.primary' }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
            {popupLoading ? (
              <Stack spacing={2}>
                {[1, 2, 3].map((_, idx) => (
                  <Box key={idx} sx={{ p: 2, border: 1, borderColor: 'divider', borderRadius: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={3}><Skeleton variant="text" width={80} height={24} /></Grid>
                      <Grid item xs={12} sm={3}><Skeleton variant="text" width={60} height={24} /></Grid>
                      <Grid item xs={12} sm={3}><Skeleton variant="text" width={60} height={24} /></Grid>
                      <Grid item xs={12} sm={3}><Skeleton variant="text" width={100} height={24} /></Grid>
                    </Grid>
                  </Box>
                ))}
              </Stack>
            ) :popupData  && (
              <Stack spacing={2}>
                {popupData.data?.map((event: any, index: number) => {
                  // Simplify event type display
                  const simplifiedEventType = event.event_type.split('-')[0].trim();
                  return (
                    <Card
                      key={index}
                      elevation={0}
                      sx={{
                        border: 1,
                        borderColor: 'divider',
                        borderRadius: 2,
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        '&:hover': isEventClickable(event) ? {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        } : {},
                        cursor: isEventClickable(event) ? 'pointer' : 'default'
                      }}
                      onClick={isEventClickable(event) ? () => handleEventCardClick(event) : undefined}
                    >
                      <Box sx={{ p: 2 }}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} sm={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <TimelineIcon color="action" sx={{ fontSize: 20 }} />
                              <Typography variant="body2" color="text.secondary">
                                {event.time}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <AssessmentIcon color="primary" sx={{ fontSize: 20 }} />
                              <Typography variant="body1" fontWeight="medium">
                                {event.security_score}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              {event.score_change > 0 ? (
                                <>
                                  <TrendingUpIcon sx={{ color: 'success.main', fontSize: 20 }} />
                                  <Typography color="success.main" fontWeight="medium">
                                    +{event.score_change.toFixed(2)}
                                  </Typography>
                                </>
                              ) : event.score_change < 0 ? (
                                <>
                                  <TrendingDownIcon sx={{ color: 'error.main', fontSize: 20 }} />
                                  <Typography color="error.main" fontWeight="medium">
                                    {event.score_change.toFixed(2)}
                                  </Typography>
                                </>
                              ) : (
                                <>
                                  <RemoveIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                                  <Typography color="text.secondary">
                                    No change
                                  </Typography>
                                </>
                              )}
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Box sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              bgcolor: isDarkMode ? 'rgba(147, 112, 219, 0.1)' : 'rgba(147, 112, 219, 0.05)',
                              borderRadius: 1,
                              px: 1.5,
                              py: 0.75,
                              width: 'fit-content'
                            }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: isDarkMode ? 'rgba(147, 112, 219, 0.9)' : 'rgba(147, 112, 219, 1)',
                                  fontWeight: 500,
                                  fontSize: '10px',
                                  maxWidth: '150px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  title: { simplifiedEventType }
                                }}
                              >
                                {simplifiedEventType}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Card>
                  );
                })}
              </Stack>
            )}
          </Box>
        </Box>
      </Drawer>

      <Drawer
        anchor="right"
        open={eventClicked}
        onClose={() => setEventClicked(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: { xs: '100%', sm: '50%' },
            bgcolor: isDarkMode ? 'background.paper' : 'white',
            boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <Box sx={{
            p: 2,
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={() => setEventClicked(false)} size="small">
                <ArrowBackIcon />
              </IconButton>
              <EventIcon color="primary" />
              <Typography variant="h6">
                Event Details
              </Typography>
              <img
                src={Layer123}
                alt="Layer123"
                style={{ height: 22, cursor: "pointer" }}
                onClick={() => {
                  if (selectedEvent?.event_code === 'new_scan' || selectedEvent?.event_code === 'rescan') {
                    if (selectedEvent?.referenceID) {
                      navigate(`/onprem/scan/${selectedEvent.referenceID}`);
                    }
                  } else if (selectedEvent?.event_code === 'cloud') {
                    navigate(`/cloud/scan/${selectedEvent.referenceID}`);
                  }
                }}
              />
            </Box>
            <IconButton onClick={() => setEventClicked(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Event Content */}
          <Box sx={{
            p: 0,
            flexGrow: 1,
            overflowY: 'auto'
          }}>
            <CyberResilienceRediretions event={selectedEvent} />
          </Box>
        </Box>
      </Drawer>


        </>
      )}
    </Box>
  );
};

export default NewAssets;
